import { useMemo } from 'react';

interface UseSuppressBusinessNameProps {
  displayBusinessName?: string | null;
  entries?: any;
  productName?: string;
}

export const useSuppressBusinessName = ({
  displayBusinessName,
  entries,
  productName,
}: UseSuppressBusinessNameProps) => {
  return useMemo(() => {
    return Boolean(
      displayBusinessName &&
        entries?.rb_feature_flagging?.featureFlagging?.dashboard?.suppressBusinessNameExclusionListWeb?.includes(
          productName
        ) &&
        !entries?.rb_feature_flagging?.featureFlagging?.dashboard
          ?.suppressBusinessNameWeb
    );
  }, [displayBusinessName, entries, productName]);
};
